<template>
    <div id="my">
        <div class="my-header">
            <div class="header-avatar">
                <img :src="userInfo.wechatInfo.headimgurl" />
                <div class="header-name">
                    <p>{{ userInfo.name }}</p>
                </div>
            </div>
        </div>
        <div class="my-count">
            <div class="count-block">
                <div class="count-block-title">{{ elder_count }}</div>
                <span>信息维护</span>
            </div>
            <div class="count-block">
                <div class="count-block-title">{{ service_count }}</div>
                <span>服务记录</span>
            </div>
            <div class="count-block">
                <div class="count-block-title">{{ self_count }}</div>
                <span>自助下单</span>
            </div>
            <div class="count-block">
                <div class="count-block-title">{{ message_count }}</div>
                <span>处理消息</span>
            </div>
        </div>
        <div class="my-list">
            <mt-cell title="我的资料" is-link to="/my/profile">
                <img slot="icon" src="../../static/profile.png" width="24" height="24">
            </mt-cell>
            <mt-cell title="报警记录" is-link to="/alarm">
                <img slot="icon" src="../../static/alarm.png" width="24" height="24">
            </mt-cell>
            <mt-cell title="服务记录" is-link to="/my/service">
                <img slot="icon" src="../../static/service.png" width="24" height="24">
            </mt-cell>
            <mt-cell title="自助下单" is-link to="/my/self">
                <img slot="icon" src="../../static/shopbag.png" width="24" height="24">
                <span v-if="self_waiting>0" class="waiting-number">{{ self_waiting }}</span>
            </mt-cell>
            <mt-cell title="客服工单" is-link to="/my/phone_order">
                <img slot="icon" src="../../static/kefu.png" width="24" height="24">
            </mt-cell>
            <mt-cell title="老人转出" is-link to="/my/transfer" v-if="userInfo.role_level!==1">
                <img slot="icon" src="../../static/transfer.png" width="24" height="24">
            </mt-cell>
            <mt-cell title="老人转入" is-link to="/my/receive" v-if="userInfo.role_level!==1">
                <img slot="icon" src="../../static/receive.png" width="24" height="24">
                <span v-if="elder_receive>0" class="waiting-number">{{ elder_receive }}</span>
            </mt-cell>
            <mt-cell title="员工审核" is-link to="/my/verify" v-if="userInfo.role_level!==1">
                <img slot="icon" src="../../static/staff.png" width="24" height="24">
                <span v-if="staff_register>0" class="waiting-number">{{ staff_register }}</span>
            </mt-cell>
            <mt-cell title="资源中心" is-link to="/my/supplier">
                <img slot="icon" src="../../static/huwai.png" width="24" height="24">
            </mt-cell>
            <mt-cell title="微信绑定" is-link to="/my/wechat">
                <img slot="icon" src="../../static/weixin.png" width="24" height="24">
            </mt-cell>
            <mt-cell title="状态切换" is-link to="/my/status">
                <img slot="icon" src="../../static/zhuangtai.png" width="24" height="24">
                <span>{{ staff_work_status }}</span>
            </mt-cell>

        </div>
        <footer-bar :messageCount="messageCount"></footer-bar>
    </div>
</template>
<style>
    #my{
        min-height:750px;
    }
    .my-header{
        display:flex;
        height:12em;
        align-items: center;
        justify-content: center;
        background: #ffcb01;
    }
    .my-header .header-avatar{
        text-align: center;
    }
    .my-header img{
        width:4em;
        height:4em;
        border-radius:4em;
    }
    .header-name{
        margin-top:.5em;
    }
    .header-name p{
        margin:.2em 0;
        font-size:14px;
    }

    .mint-cell .mint-cell-title{
        padding:.7em 0;
    }

    .my-count{
        display:flex;
        flex-direction: row;
        padding:1em 0;
        background:#fff;
    }

    .count-block{
        width:25%;
        text-align:center;
    }

    .count-block-title{
        font-size:1.3em;
    }

    .count-block span{
        color:#5a5a5a;
        font-size:14px;
    }

    .my-list{
        margin-top:10px;
        padding-bottom: 80px;
    }

    .mint-cell{
        border-bottom: 1px solid #f4f4f4;
    }

    .waiting-number{
        display: block;
        color: #FFFFFF;
        height: 20px;
        width:20px;
        line-height: 20px;
        text-align: center;
        background:#ffcb01;
        border-radius:10px;
    }
</style>
<script>
    import Footer from '../components/footer.vue'
    export default{
        components: {
            'footer-bar': Footer
        },
        data(){
            return {
                userInfo:JSON.parse(window.localStorage.getItem('UserInfo')),
                messageCount:0,
                elder_count:0,
                service_count:0,
                self_count:0,
                self_waiting:0,
                message_count:0,
                elder_receive:0,
                staff_register:0,
                staff_work_status:''
            }
        },
        created(){
            this.$axios.get("/my/count?openid="+this.userInfo.openid).then(data => {
                if(data.data.code === 'OK'){
                    this.elder_count = data.data.elder;
                    this.service_count = data.data.service;
                    this.self_count = data.data.self;
                    this.self_waiting = data.data.self_waiting;
                    this.message_count = data.data.message;
                    this.elder_receive = data.data.elder_receive;
                    this.staff_register = data.data.staff_register;
                    this.staff_work_status = data.data.staff_work_status;
                }

            });

            this.$axios.get("/message/count?openid="+this.userInfo.openid).then(data => {
                if(data.data.code === 'OK'){
                   this.messageCount = data.data.data;
                }

            });
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/my.vue